import { render, staticRenderFns } from "./TrendInspiration.vue?vue&type=template&id=e468c348&scoped=true&name=trend-inspiration&"
import script from "./TrendInspiration.vue?vue&type=script&lang=js&"
export * from "./TrendInspiration.vue?vue&type=script&lang=js&"
import style0 from "./TrendInspiration.vue?vue&type=style&index=0&id=e468c348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e468c348",
  null
  
)

export default component.exports